// extracted by mini-css-extract-plugin
export default {"container":"ContactDealer_container__+s3DV","formArea":"ContactDealer_formArea__a7FO5","text-area":"ContactDealer_text-area__lXq4m","send-button":"ContactDealer_send-button__Bvhu9"};